var pjax = require('./lib/pjax');

document.addEventListener("latte:init", init);

function init () {



    // simple show/hide account details info
    $(window).on('keyup', function(e) {
        if(e.which == 13) {
            if($(e.target).is('#account')) {
                $('.account-menu').addClass('show');
                $('.account-menu').focus();
            }
            if($(e.target).is('#search-handle')) {
                $('header #search-handle').click();
            }
        }
        if(e.which == 9) {
            if(!$(e.target).is('#account') && !$(e.target).hasClass('account-sub-menu-item')) {
               $('.account-menu').removeClass('show');
            }
        }
    });









  // function for determining one or two row header
  var communityWidth = 0;
  var utilWidth = 0;
  var mastHeadRightWidth = $('.masthead--right').width();
  var logoWidth = $('.masthead--left').outerWidth(true);

  //Windows will calc browser with differently. If the width is smaller than 1024 onload, use the smaller width so we dont overflow the container
  var mastheadWidth = $('.masthead').outerWidth(true) < 1024 ? $('.masthead').outerWidth(true) : 1024;

  //measure community menu items
  $('.community-menu .level-1-item').each(function(){
      communityWidth += $(this).outerWidth(true);
      // communityWidth += 34;
  });

  //measure utilities
  $('.utilities > *').each(function(){
      utilWidth += $(this).outerWidth(true);
  });

  //if community menu cannot fit between utilites and logo at 1024 screen size, do two row layout
  if (communityWidth + 13 >= (mastheadWidth - utilWidth - logoWidth)) {
    $('.page-header').addClass('thick');
    $('.pdp-sticker-placeholder').addClass('thick');

    //unhide community menu after calculation to prevent flash
    $('.community-menu-wrapper').removeClass('clear');
  } else {

    //unhide community menu after calculation to prevent flash
    $('.community-menu-wrapper').removeClass('clear');
  }
  // END function for determining one or two row header



    // FOR Sticky Header code:  see stickers.js

    $(".directory-handle, .screened").click(function (e) {
        if ($(window).width() < 1024) {
            $('.directory-handle').toggleClass('open');
            $('.directory-handle .drawer').toggle();
            $('.directory-handle .times').toggle();
            $('.directory-list').toggleClass("slide-in");
            $('.mobile-utilities').toggleClass("slide-in");
            $('.active-community').toggleClass('active');
            $('.cx-side-button-group').toggleClass('hide-chat');
            $('.screened').toggleClass("opacity");
            $('.content-container').toggleClass('fixed-position');
            e.preventDefault();
        }
    });

    $(".screened").click(function (e) {
        if ($(window).width() < 1024) {
            $('.directory-handle').show().removeClass('times').addClass('drawer');
            $('.mobile-search-page').hide();
            $('.directory-handle').show();
            e.preventDefault();
        }
    });

    $(".directory li a").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $(".directory .level-4-item ").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        pjax.loadUrl($(this).attr('data-href')); //will refresh the content container
    });

    // cap height on level-4 to prevent link list overflowing height of screen. 110 = bottom utilities height + back link button
    $('.level-4').css({ "height": $(window).height() - 110 });

    // max heigh on directory list b/c 100vh issue in mobile browsers
    // https://bugs.webkit.org/show_bug.cgi?id=141832
    // if($(window).width() <= 1023) {
    // $('.directory-list').css({"height": ($(window).height()-59)});
    // }

    $(".directory .level-3-item ").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('top')) { //drill up
            $(this).removeClass('top').removeClass('pull');
            $(".level-3-item").removeClass('hidden').addClass('active');
            $(this).find(".level-4-item").removeClass('active').addClass('hidden');
            $(this).find(".level-4").removeClass('active').addClass('hidden');
            $(".level-2-item").removeClass('pull');
            $(".level-1-item").removeClass('pull');

        } else if ($(this).hasClass('has-child')) {
            $(".level-3-item").addClass('hidden');
            $(this).addClass('top').addClass('pull').removeClass('hidden').addClass('active');
            $(this).find(".level-4").removeClass('hidden').addClass('active');
            $(this).find(".level-4-item").removeClass('hidden').addClass('active');
            $(".level-2-item").addClass('pull');
            $(".level-1-item").addClass('pull');

        } else {//go to link
            pjax.loadUrl($(this).attr('data-href')); //will refresh the content container
        }
    });

    //navigate
    $(".directory .level-2-item").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('top')) { //drill up
            $(this).removeClass('top');
            $(".level-2.active-community .level-2-item").removeClass('hidden').addClass('active');
            $(".level-2").addClass('push');
            $(this).find(".level-3").removeClass('active');
            $(".level-1-item.active-community").addClass('top');
            $(".level-1-item").removeClass('pull');

        } else if ($(this).hasClass('link')) {
            pjax.loadUrl($(this).attr('data-href')); //will refresh the content container

        } else if ($(this).hasClass('active-community')) { //drill down
            $(".level-1-item").removeClass('top').addClass('pull');
            $(this).addClass('top');
            $(".level-2").removeClass('push');

            $(".level-2-item").removeClass('active').addClass('hidden');
            $(this).removeClass('hidden').addClass('active');
            $(this).find(".level-3").addClass('active');

        } else { // go to link
            pjax.loadUrl($(this).attr('data-href')); //will refresh the content container
        }


    });


    $(".directory .level-1-item").click(function (e) {
        e.preventDefault();

        if ($(this).hasClass('top')) { //drill up
            $(this).removeClass('top');
            $(".level-1-item").removeClass('hidden').addClass('active');
            $(this).find(".level-2-item").removeClass('active').addClass('hidden');
            $(this).find(".level-2").removeClass('active').addClass('hidden');

        } else if ($(this).hasClass('no-child')) { //go to link
            pjax.loadUrl($(this).attr('data-href')); //will refresh the content container

        } else {
            $(".level-1-item").addClass('hidden');
            $(this).addClass('top').removeClass('hidden').addClass('active');
            $(this).find(".level-2").removeClass('hidden').addClass('active');
            $(this).find(".level-2-item").removeClass('hidden').addClass('active');
        }
    });



    $('input').on('focus', function (e) {
        if ($(this).val() === "search by keyword or class code") {
            $(this).val("");
        }
    });


    searchBarExpand = false;
    $('header #search-handle').click(function (e) {

        if (!searchBarExpand) {
            $('.search').addClass('search-bar--expanded');
            $('#phone').addClass('hide');
            $('#account').addClass('hide');
            $('#sign-in').addClass('hide');
            $('.search-icon').find('svg').toggle();
            $('.search-icon--before').css({ "display": "flex" });
            $('.search form input').show();
            $('.signin-wrapper').hide();

            searchBarExpand = true;
        } else {
            $('.search').removeClass('search-bar--expanded');
            $('#phone').removeClass('hide');
            $('#account').removeClass('hide');
            $('#sign-in').removeClass('hide');
            $('.search-icon').find('svg').toggle();
            $('.search-icon--before').css({ "display": "none" });
            $('.search form input').hide();
            $('.signin-wrapper').show();

            searchBarExpand = false;

        }

    });

    $('header #mobile-search-handle, #mobile-search-cancel').click(function (e) {
        $('.mobile-search-page').toggle();
        $('.directory-handle').toggle();
    });

    $('header #mobile-search-clear').click(function (e) {
        $('.mobile-search input').val("");
    });


    $('.search-form-input').submit(function (e) {
        e.preventDefault();
        return false;
    });

    $('.search-form-input').find('input').keyup(function (e) {
        var code = e.keyCode || e.which;
        if (code == 13 && $(this).val() !== "" && $(this).val() !== "search by keyword or class code") {
            helper.search($(this).val());
            e.preventDefault();
            return false;
        }
    });

    $('header .search-icon--before.js-desktop-search').click(function (e) {
      helper.search($('.search-form-input input').val());
    });

    //check cartItemCount cookie
    if ((helper.readCookie('cartItemCount') !== undefined) && (helper.readCookie('cartItemCount') !== '0')) {
        $('.cart .cart-empty').hide();
        $('.cart .cart-full').show();
    }

    //check for signed in cookie
    if ((helper.readCookie('_KTPAID') !== undefined && helper.readCookie('_KTPAID') !== null && helper.readCookie('_KTPAID') !== 'null') && (helper.readCookie('_KTPA') !== undefined && helper.readCookie('_KTPA') !== null && helper.readCookie('_KTPA') !== 'null') && (helper.readCookie('_KTPA_CONFIRM') !== undefined && helper.readCookie('_KTPA_CONFIRM') !== null && helper.readCookie('_KTPA_CONFIRM') !== 'null')) {

        if ($(window).width() < 1024) {
            $('#mobile-account').show();
            $('#mobile-sign-in').hide();
            $('#mobile-contact').show();
            $('#mobile-phone').hide();
        } else {
            $('#account').removeClass("no-cookie");
            $('#sign-in').hide();
            $('#contact').css({ "display": "flex" });
            $('#phone').hide();
        }
    }

    // handle new alert banner
    $('.close-alert-btn').click(function () {
        if (sessionStorage) {
            sessionStorage.setItem('showAlert', false);
        }

        $('.page-alert--yellow').hide();
    });
}



//////////////////
// WEBPACK FOOTER
// ./public/js/header.js
// module id = 74
// module chunks = 0